import { render, staticRenderFns } from "./Induction.vue?vue&type=template&id=5a897196&"
import script from "./Induction.vue?vue&type=script&lang=js&"
export * from "./Induction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports